export enum FeatureLayerType {
  Root = 'Root',
  Folder = 'Folder',
  Point = 'Point',
  Line = 'Line',
  Area = 'Area',
  Model3d = 'Model3d',
  Unknown = 'Unknown',
}
